import { connect } from 'react-redux';
import { IApplicationState, TCardId } from '../../../../../../../types/types';
import { ICardDatesCloseButtonHOCProps } from './types';
import { onClick } from './events/onClick';
import { ICardDatesCloseButtonEvents, ICardDatesCloseButtonFields } from '../../components/CardDatesCloseButton/types';
import { CardDatesCloseButton } from '../../components/CardDatesCloseButton/CardDatesCloseButton';
import { getCard } from '../../../../../../../store/model/selectors/getCard';
import { getCardSubcardIdWithMaxDate } from './selectors/getCardSubcardIdWithMaxDate';
import { getCardSubcardIdWithMinDate } from './selectors/getCardSubcardIdWithMinDate';
import { EDateType } from '../../../../../../../const';

const mapStateToProps = (
    state: IApplicationState,
    { cardId, type }: ICardDatesCloseButtonHOCProps
): ICardDatesCloseButtonFields => {
    let cardName;
    let dateCardId;
    if (cardId) {
        const epic = getCard(state, cardId);
        if (type === EDateType.DUE_DATE) {
            dateCardId = getCardSubcardIdWithMaxDate(state, cardId);
            const card = getCard(state, dateCardId);
            cardName = card && card.dueDate && epic && epic.dueDate && card.dueDate >= epic.dueDate ? card.name : null
        }
        if (type === EDateType.START_DATE) {
            dateCardId = getCardSubcardIdWithMinDate(state, cardId);
            const card = getCard(state, dateCardId);
            cardName = card && card.startDate && epic && epic.startDate && card.startDate <= epic.startDate ? card.name : null
        }
    }
    return {
        dateCardId,
        name: cardName
    }
};

const mapDispatchToProps = (
    dispatch: any,
): ICardDatesCloseButtonEvents => {
    return {
        onClick: (cardId) => dispatch(onClick(cardId))
    }
};

export const CardDatesCloseButtonHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(CardDatesCloseButton);

CardDatesCloseButtonHOC.displayName = 'CardDatesCloseButtonHOC';
